export var DataHubActions;
(function (DataHubActions) {
    DataHubActions["ClickCreateModule"] = "click_create_module";
    DataHubActions["TryAddPageCover"] = "try_add_page_cover";
    DataHubActions["TryCreateModuleCover"] = "try_create_module_cover";
    DataHubActions["TryPageCreate"] = "try_page_create";
    DataHubActions["TryPagePublish"] = "try_page_publish";
    DataHubActions["TryPageUpdate"] = "try_page_update";
    DataHubActions["ViewBulkDelete"] = "view_bulk_delete_content";
    DataHubActions["ViewBulkPublish"] = "view_admin_bulk_publish";
    DataHubActions["ViewBulkUndoPublish"] = "view_bulk_undopublish";
    DataHubActions["ViewClassConfig"] = "view_class_config";
    DataHubActions["ViewContentCreate"] = "view_content_create";
    DataHubActions["ViewContentEdit"] = "view_content_edit";
    DataHubActions["ViewCoursePersonalization"] = "view_course_personalization";
    DataHubActions["ViewExtraMaterial"] = "view_extra_material";
    DataHubActions["ViewModuleCreate"] = "view_module_create";
    DataHubActions["ViewModuleCreateBottomsheet"] = "view_module_create_bottomsheet";
    DataHubActions["ViewPageAs"] = "view_page_as";
    DataHubActions["ClickContentPageMenu"] = "click_content_page_menu";
    DataHubActions["ClickContentPageEdit"] = "click_content_page_edit";
    DataHubActions["ClickContentPageViewAs"] = "click_content_page_view_as";
    DataHubActions["ClickContentPageDuplicate"] = "click_content_page_duplicate";
    DataHubActions["ClickContentPageDelete"] = "click_content_page_delete";
    DataHubActions["ClickContentModuleMenu"] = "click_content_module_menu";
    DataHubActions["ClickContentModuleEdit"] = "click_content_module_edit";
    DataHubActions["ClickContentModuleDuplicate"] = "click_content_module_duplicate";
    DataHubActions["ClickContentModuleDelete"] = "click_content_module_delete";
    DataHubActions["ClickContentSearch"] = "click_content_search";
    DataHubActions["TryContentSearch"] = "try_content_search";
    DataHubActions["ClickContentListSelectAll"] = "click_content_list_select_all";
    DataHubActions["ClickContentExpandModules"] = "click_content_expand_modules";
    DataHubActions["ClickContentExpandOneModule"] = "click_content_expand_one_module";
    DataHubActions["ClickContentCheckAllPages"] = "click_content_check_all_pages";
    DataHubActions["ClickContentCheckPage"] = "click_content_check_page";
    DataHubActions["ClickContentModuleNameEdit"] = "click_content_module_name_edit";
    DataHubActions["TryContentModuleNameEdit"] = "try_content_module_name_edit";
    DataHubActions["ClickContentPageNameEdit"] = "click_content_page_name_edit";
    DataHubActions["TryContentPageNameEdit"] = "try_content_page_name_edit";
    DataHubActions["ClickContentAddPageOptions"] = "click_content_add_page_options";
    DataHubActions["ClickContentCreatePage"] = "click_content_create_page";
    DataHubActions["TryContentOrderModule"] = "try_content_order_module";
    DataHubActions["TryContentOrderPage"] = "try_content_order_page";
    DataHubActions["ClickContentShowModuleGroups"] = "click_content_show_module_groups";
    DataHubActions["ViewBulkDrippingDelete"] = "view_bulk_dripping_delete";
    DataHubActions["ViewBulkDrippingCreate"] = "view_bulk_dripping_create";
})(DataHubActions || (DataHubActions = {}));
